// extracted by mini-css-extract-plugin
export default {"root":"HybridChip_root__PDWrU"};